<template>
  <div>
    <p class="xPadding titleModal">
      {{
        $t(`treatmentProgram.step3.targetDosage`)
      }}
    </p>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.ppm"
          :label="$t('treatmentProgram.steam.step4.ppm')"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.pumpModel"
          :label="$t('treatmentProgram.steam.step4.pumpModel')"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- MaximumPumpPressure -->
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.maximumPumpPressure.value"
          :label="$t('treatmentProgram.steam.step4.maximumPumpPressure')"
          :formatNumber="true"
          type="number"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.maximumPumpPressure.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="maximumPumpPressureUnit"
          itemValue="key"
          itemText="name"
          outlined
          flat
          data-cy="injectionCibleUnit"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- Maximum Pump Rating -->
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.maximumPumpRating.value"
          :label="$t('treatmentProgram.steam.step4.maximumPumpRating')"
          :formatNumber="true"
          type="number"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.maximumPumpRating.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="ratingUnit"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- Real Flow Rate -->
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.realFlowRate.value"
          :label="$t('treatmentProgram.steam.step4.realFlowRate')"
          :formatNumber="true"
          type="number"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
      <v-col class="py-0">
        <VSelect
          v-model="data.realFlowRate.unit"
          :label="$t('treatmentProgram.step2.unit')"
          :items="ratingUnit"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { MAXIMUM_PUMP_PRESSURE_UNIIT, RATING_UNIT } from '@/constants/steamTreatmentPrograms';
import { cloneDeep } from 'lodash';

export default {
    components: {
        VTextField,
    },
    props: {
        targetDosage: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                maximumPumpPressure: {},
                maximumPumpRating: {},
                realFlowRate: {},
            },
        };
    },
    computed: {
        maximumPumpPressureUnit() {
            return MAXIMUM_PUMP_PRESSURE_UNIIT.map(key => ({
                name: this.$t(`treatmentProgram.steam.step4.maximumPumpPressureUnit.${key}`),
                key,
            }));
        },
        ratingUnit() {
            return RATING_UNIT.map(key => ({
                name: this.$t(`treatmentProgram.steam.step4.ratingUnit.${key}`),
                key,
            }));
        },
    },
    watch: {
        targetDosage: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.targetDosage) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { targetDosage: this.data });
        },
    },
};
</script>
  <style lang="scss" scoped>
  .xPadding{
    padding: 0 6rem;
  }
  @media screen and (max-width: 600px) {
     .xPadding{
        padding: 0;
      }
  }
  </style>
